export default __webpack_public_path__ + "static/media/NuvemShop.b52d25a0.png";